import { arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { string, boolean, number } from "@altostra/type-validations/lib/primitives";

export const isFeatureFlagsRolloutDependenciesResults = objectOf({
  has_dependencies: boolean,
  usage: maybe(
    objectOf({
      steps_using_rollout: maybe(
        objectOf({
          count: number,
          data: arrayOf(
            objectOf({
              id: string,
              name: string,
              type: string,
              workflow_id: string,
              is_active: boolean,
            })
          ),
        }),
        true
      ),
      experiments_using_rollout: maybe(
        objectOf({
          count: number,
          data: arrayOf(
            objectOf({
              id: string,
              name: string,
              description: maybe(string, true),
              campaign_type: string,
              is_active: boolean,
            })
          ),
        }),
        true
      ),
      segments_with_filters_using_rollout: maybe(
        objectOf({
          count: number,
          data: arrayOf(
            objectOf({
              id: string,
              name: string,
              description: maybe(string, true),
              is_active: boolean,
            })
          ),
        }),
        true
      ),
      campaigns_with_filters_using_rollout: maybe(
        objectOf({
          count: number,
          data: arrayOf(
            objectOf({
              id: string,
              name: string,
              description: maybe(string, true),
              campaign_type: string,
              is_active: boolean,
            })
          ),
        }),
        true
      ),
      workflows_with_filters_using_rollout: maybe(
        objectOf({
          count: number,
          data: arrayOf(
            objectOf({
              id: string,
              name: string,
              description: string,
              is_active: boolean,
            })
          ),
        }),
        true
      ),
      rollout: objectOf({
        id: string,
        name: string,
        description: string,
        app_group_id: string,
        company_id: string,
      }),
    }),
    true
  ),
});
